import http from "../utils/http-common";

const getAllSystems = () => {
  const param = { mode: "all" };
  const queryString = new URLSearchParams(param).toString();
  return http.get(`/system/registry?${queryString}`);
};
const getSystem = (params: string) => {
  const queryString = new URLSearchParams(params).toString();
  return http.get(`/system/registry?${queryString}`);
};
const postSystem = (data: any) => {
  return http.post(`/system/registry`, data);
};
const putSystem = (data: any) => {
  return http.put(`/system/registry`, data);
};
const deleteSystem = (id: any) => {
  return http.delete(`/system/registry/${id}`);
};
const systemRegistry = {
  getAllSystems,
  getSystem,
  postSystem,
  putSystem,
  deleteSystem,
};

export default systemRegistry;
